<template>
  <vuex-table
    :fields="fields"
    :show_filter="true"
    :filter_items="filtered_fields"
    table_store="voice/sip-trunks/table"
  >
    <template slot="filter">
      {{ $t('voice.trunk.button.show_default_trunks') }}
      <z-switch v-model="show_default_trunks" class="ml-3" @on-change="submit" />
    </template>
    <template slot="type" slot-scope="{ item }">
      {{ $t(`voice.trunk.type.${item.type}`) }}
    </template>

    <template #client="{ detailsShowing, toggleDetails, item }">
      <div class="mainip_more">
        <span>{{ item.client }}</span>
        <table-button-more :is_show="detailsShowing" :is_text="false" @click="toggleDetails" />
      </div>
    </template>

    <template #row-details="{ item }">
      <table-ips :id="item.id" :server="item.server" />
    </template>

    <template slot="actions" slot-scope="{ item }">
      <table-dropdown>
        <span
          v-if="is_trunk_allowed"
          class="dropdown-item-icon dropdown-item-icon--disabled dropdown-item-icon--edit"
          @click="edit_item(item)"
        >
          {{ $t('shared.component.table.action.edit') }}
        </span>
        <span
          v-if="is_trunk_allowed"
          class="dropdown-item-icon dropdown-item--disabled dropdown-item-icon--ip"
          @click="add_ip(item)"
        >
          {{ $t('shared.component.table.action.add_ip') }}
        </span>
        <span class="dropdown-item-icon dropdown-item-icon--trash" @click="remove_item(item)">
          {{ $t('shared.component.table.action.delete') }}
        </span>
      </table-dropdown>
    </template>
    <template slot="state" slot-scope="{ formatted: value }">
      <status-badge :value="value" />
    </template>
  </vuex-table>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { TrunkModalService } from '@voice/modals/TrunkModalService';
  import StatusBadge from '@voice/components/sip-badge-state';
  import { DATA } from '@/plugins/vuex-async-pagginate';
  import TableButtonMore from '@shared/components/table/table-cell-toggle-detail';
  import TableIps from '@voice/components/trunks-table-ips';

  export default {
    components: {
      StatusBadge,
      TableButtonMore,
      TableIps
    },

    props: {
      filtred_data: {
        type: String,
        default: ''
      }
    },
    data: () => ({
      show_default_trunks: false
    }),

    computed: {
      ...mapGetters('voice/sip-trunks/table', { items: DATA }),
      ...mapGetters('core/auth', ['permissions']),

      is_trunk_allowed() {
        return this.permissions.manage_trunks_is_allowed;
      },

      filtered_fields: function () {
        if (!this.filtred_data) return this.items;

        return this.items.filter((f) => {
          return f.service_name === this.filtred_data;
        });
      },
      fields: function () {
        return [
          {
            key: 'name',
            label: this.$t('shared.component.table.field.name'),
            sortable: true,
            class: 'w-20'
          },
          {
            key: 'client',
            label: this.$t('voice.trunk.field.my_ip'),
            sortable: true,
            class: 'w-15 pos-r',
            showMore: true
          },
          {
            key: 'server',
            label: this.$t('voice.trunk.field.zorra_ip'),
            sortable: true,
            class: 'w-15'
          },
          {
            key: 'prefix',
            label: this.$t('voice.trunk.field.prefix'),
            class: 'w-15'
          },
          {
            key: 'state',
            label: this.$t('voice.trunk.field.state'),
            class: 'w-5'
          },
          {
            key: 'type',
            label: this.$t('voice.trunk.field.type'),
            sortable: true,
            class: 'w-10'
          },
          {
            key: 'service_name',
            label: this.$t('voice.trunk.field.trunk_type'),
            formatter: (value) => this.$t(`voice.trunk.type.${value}`),
            class: 'w-10',
            thStyle: { minWidth: '250px' }
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'w-10 table-actions'
          }
        ];
      }
    },
    created() {
      this.search({
        is_auto_created: 0
      });
    },
    methods: {
      ...mapActions('voice/sip-trunks/table', ['getAsyncData', 'updateItemById']),
      ...mapActions('voice/sip-trunks/table', ['search']),

      submit: function () {
        if (this.show_default_trunks) {
          this.search({
            current_page: 1
          });
        } else {
          this.search({
            current_page: 1,
            is_auto_created: 0
          });
        }
      },

      remove_item: function (item) {
        TrunkModalService.remove(item.id, item).on('success', () => this.getAsyncData());
      },

      edit_item: function (item) {
        if (this.is_trunk_allowed) {
          TrunkModalService.edit(item.id, item).on('success', () => this.getAsyncData());
        }
      },

      add_ip: function (item) {
        if (this.is_trunk_allowed) {
          TrunkModalService.add_ip(item).on('success', () => this.getAsyncData());
        }
      }
    }
  };
</script>

<style lang="scss">
  .w-5 {
    width: 5%;
  }

  .w-10 {
    width: 10%;
  }

  .w-15 {
    width: 15%;
  }

  .w-20 {
    width: 20%;
  }

  .table-edit td {
    vertical-align: top;
  }

  table .pos-r {
    position: relative;
  }

  .mainip_more {
    a.table-button-more {
      position: absolute;
      left: 140px;
      display: block;
      top: 15px;
    }
  }
</style>
